<template>
  <div class="layout">
    <div class="menu">
      <Menu topIndex="4"></Menu>
    </div>
    <div class="leftSide">
      <LeftSideBar current="dbWork" leftIndex="8"></LeftSideBar>
    </div>
    <div id="deptContentBox" class="base-content">
      <!-- 上方按钮 -->
      <div>
        <el-button
          type="text"
          size="small"
          icon="el-icon-plus"
          @click="firstCreate()"
          >新增</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-close"
          @click="deletePre()"
          >删除</el-button
        >
      </div>
      <!-- 上方按钮end -->
      <!-- 搜索 -->
      <div id="searchBox">
        <el-form label-width="80px">
          <el-form-item label="名称">
            <el-input placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item label="来源">
            <el-select placeholder="请输入来源">
              <el-option>未上架</el-option>
              <el-option>已上架</el-option>
              <el-option>已下架</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="资源状态">
            <el-select placeholder="请输入资源状态">
              <el-option>未上架</el-option>
              <el-option>已上架</el-option>
              <el-option>已下架</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label-width="0px">
            <el-button type="primary" size="mini" icon="el-icon-search"
              >查询</el-button
            >
            <el-button type="primary" size="mini" icon="el-icon-delete"
              >重置
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 搜索end -->
      <el-table
        :data="tableData"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        style="width: 100%"
        border
        :header-cell-style="{ background: '#f8f8f8' }"
      >
        <el-table-column
          type="selection"
          min-width="55"
          align="center"
        ></el-table-column>
        <el-table-column type="index" min-width="50" align="center">
        </el-table-column>
        <el-table-column
          prop="name"
          show-overflow-tooltip
          min-width="80"
          label="条目名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="address"
          min-width="80"
          label="义项名称"
          align="center"
        >
        </el-table-column>
        <el-table-column show-overflow-tooltip label="学科层级" align="center">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="项目来源"
          min-width="70px"
          align="center"
        >
        </el-table-column>
        <el-table-column show-overflow-tooltip label="状态" align="center">
          <template>
            <span>已锁定</span>
            <span>未锁定</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="最新操作时间"
          align="center"
        >
        </el-table-column>
      </el-table>
      <!-- <div class="pagination-box">
        <el-pagination
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSize"
        >
        </el-pagination>
      </div> -->
    </div>
    <el-dialog
      title="新增机构"
      :visible.sync="createDialog"
      width="600px"
      @open="noClick = false"
    >
      <el-form>
        <el-form-item label="机构名称" label-width="80px">
          <el-input placeholder="请输入机构名称"></el-input>
        </el-form-item>
        <el-form-item label="机构状态" label-width="80px"> </el-form-item>
        <el-form-item label="手机号码" label-width="80px">
          <el-input placeholder="请输入手机号码"></el-input>
        </el-form-item>
        <el-form-item label="联系人" label-width="80px">
          <el-input placeholder="请输入联系人"></el-input>
        </el-form-item>
        <el-form-item label="机构描述" label-width="80px">
          <el-input placeholder="请输入机构描述"></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Menu from "../../menu/menu.vue";
import LeftSideBar from "../../menu/leftSideBar.vue";
// import $ from "jquery";
export default {
  components: {
    Menu,
    LeftSideBar,
  },
  data() {
    return {
      current: "dept",
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1517 弄",
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1519 弄",
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1516 弄",
        },
      ],
      createDialog: false,
    };
  },
  methods: {
    // 显示新增弹框
    firstCreate() {
      this.createDialog = true;
      this.addDeptForm = {
        username: "",
        realName: "",
        password: "",
        tel: "",
        deptId: "",
      };
      // 部门树开始
      this.SelectvalueTitle = "";
      // 部门树结束
    },
    deletePre() {},
  },
};
</script>

<style>
</style>